import { render, staticRenderFns } from "./SortDown.vue?vue&type=template&id=cb6a7b42"
import script from "./SortDown.vue?vue&type=script&lang=js"
export * from "./SortDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports